/** OnboardL10Details — thin route wrapper for the shared L10 wizard.
 *
 *  The user picks Casting vs Talent Management on /onboard/casting-agency
 *  (see OnboardCastingType) which then routes here with
 *  location.state.kind in {"casting_agency", "talent_management_agency"}.
 *
 *  We delegate to OnboardGeneric which already has KIND_CFG entries for
 *  both. If the user lands here directly (no route state, e.g. via a
 *  browser refresh mid-wizard) we bounce them back to the picker.
 */
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OnboardGeneric from "@/pages/OnboardGeneric";

const VALID = new Set(["casting_agency", "talent_management_agency"]);

export default function OnboardL10Details() {
  const loc = useLocation();
  const nav = useNavigate();
  const kind = loc.state?.kind;

  useEffect(() => {
    if (!kind || !VALID.has(kind)) {
      nav("/onboard/casting-agency", { replace: true });
    }
  }, [kind, nav]);

  if (!kind || !VALID.has(kind)) return null;
  return <OnboardGeneric kind={kind} />;
}
